import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  ChevronRight as ChevronRightIcon,
  Call as CallIcon,
} from "@mui/icons-material";
import { Link } from "gatsby";

const Button = ({
  className = "",
  label,
  iconClassName = "",
  showRightArrow = false,
  showLeftCallIcon = false,
  type = "button",
  variant,
  onPress,
  link = {
    is: false,
    path: "/",
    isExternal: false,
  },
}) => {
  return (
    <Fragment>
      {link.is ? (
        link.isExternal ? (
          <a className="no-underline" href={link.path}>
            <button
              aria-label={`Btn-${label}`}
              className={`${className} transition duration-300 px-6 py-2 rounded-full text-base font-medium flex items-center justify-center ${
                variant === "primary"
                  ? "text-white px-6 py-2 bg-green-700 hover:bg-green-800"
                  : variant === "outline"
                  ? "bg-transparent px-[15px] desktop:px-6 py-2 hover:bg-green-700 hover:text-white text-green-700 border-2 border-green-700"
                  : ""
              }`}
              onClick={onPress}
              type={type}
            >
              {showLeftCallIcon && <CallIcon className="me-1" />}
              {label}
              {showRightArrow && (
                <ChevronRightIcon
                  className={`${iconClassName} text-green-500bg-green-700 bg-white ms-2 !text-base rounded-full`}
                />
              )}
            </button>
          </a>
        ) : (
          <Link className="no-underline" to={link.path}>
            <button
              aria-label={`Btn-${label}`}
              className={`${className} transition duration-300 px-6 py-2 rounded-full text-base font-medium flex items-center justify-center ${
                variant === "primary"
                  ? "text-white px-6 py-2 bg-green-700 hover:bg-green-800"
                  : variant === "outline"
                  ? "bg-transparent px-[15px] desktop:px-6 py-2 hover:bg-green-700 hover:text-white text-green-700 border-2 border-green-700"
                  : ""
              }`}
              onClick={onPress}
              type={type}
            >
              {showLeftCallIcon && <CallIcon className="me-1" />}
              {label}
              {showRightArrow && (
                <ChevronRightIcon
                  className={`${iconClassName} text-green-500bg-green-700 bg-white ms-2 !text-base rounded-full`}
                />
              )}
            </button>
          </Link>
        )
      ) : (
        <button
          aria-label={`Btn-${label}`}
          className={`${className} transition duration-300 px-6 py-2 rounded-full text-base font-medium flex items-center justify-center ${
            variant === "primary"
              ? "text-white px-6 py-2 bg-green-700 hover:bg-green-800"
              : variant === "outline"
              ? "bg-transparent px-[15px] desktop:px-6 py-2 hover:bg-green-700 hover:text-white text-green-700 border-2 border-green-700"
              : ""
          }`}
          onClick={onPress}
          type={type}
        >
          {showLeftCallIcon && <CallIcon className="me-1" />}
          {label}
          {showRightArrow && (
            <ChevronRightIcon
              className={`${iconClassName} text-green-500bg-green-700 bg-white ms-2 !text-base rounded-full`}
            />
          )}
        </button>
      )}
    </Fragment>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  showRightArrow: PropTypes.bool,
  showLeftCallIcon: PropTypes.bool,
  label: PropTypes.any.isRequired,
  variant: PropTypes.oneOf(["primary", "outline"]).isRequired,
  onPress: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  link: PropTypes.exact({
    is: PropTypes.bool,
    path: PropTypes.string,
    isExternal: PropTypes.bool,
  }),
};

export default Button;
